import React from 'react';

const Download2SVG = ({ color, className, onClick, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='22'
      height='22'
      viewBox='0 0 22 22'
      fill='none'
      onClick={onClick}
      className={className}
    >
      <path
        d='M1.64551 11.3226V18.8495C1.64551 19.4198 1.87208 19.9668 2.27539 20.3701C2.67869 20.7734 3.22569 21 3.79605 21H18.8498C19.4202 21 19.9672 20.7734 20.3705 20.3701C20.7738 19.9668 21.0003 19.4198 21.0003 18.8495V11.3226'
        stroke='black'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.91406 11.3226L11.3227 15.6237L15.7313 11.3226'
        stroke='black'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M11.3223 1V13.3656'
        stroke='black'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Download2SVG;
